import { FC } from 'react';
import { Select, MenuItem, Typography } from '@mui/material';
import './TaskChartSelector.scss';
import { useTranslation } from 'react-i18next';
interface TaskChartSelectorProps {
  value: TaskChartSelectorOption;
  onChange: (value: TaskChartSelectorOption) => void;
}

export type TaskChartSelectorOption = 'label' | 'zone';

export const TaskChartSelector: FC<TaskChartSelectorProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    onChange(event.target.value as TaskChartSelectorOption);
  };

  const commonStyles = {
    height: '32px',
    backgroundColor: 'var(--color-gray-purple)',
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiSelect-select': {
      padding: '4px 12px',
      borderRadius: '8px',
      fontWeight: '500',
    },
  };

  const selectComponent = (
    <Select
      value={value}
      onChange={handleChange}
      sx={{
        ...commonStyles,
        '& .MuiSelect-select': {
          ...commonStyles['& .MuiSelect-select'],
          fontSize: '16px',
          color: 'var(--color-gray-medium) !important',
        },
      }}
      MenuProps={{
        className: 're-task-chart-selector__dropdown',
        sx: { '& .MuiMenuItem-root': { fontSize: '12px' } },
      }}
    >
      <MenuItem value="label">{t('data.task.chartModes.label')}</MenuItem>
      <MenuItem value="zone">{t('data.task.chartModes.zone')}</MenuItem>
    </Select>
  );

  return <div className="re-task-chart-selector">{selectComponent}</div>;
};
